module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-medium is-fullwidth",
    on: {
      "click": _vm.editUser
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba5194a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserNew.vue
// module id = 338
// module chunks = 1